<template>
	<!-- 应用中心首页 -->
	<v-container fluid class="px-0" style="height: 100%">
		<div class="pb-3" style="width: 100%; height: 100%">
			<v-card class="ma-3" style="height: 100%" elevation="0">
				<v-card-title>
					<v-btn @click="$router.push('/uams/apps')" color="blue" icon><v-icon>mdi-arrow-left</v-icon></v-btn>
					开发中心
				</v-card-title>
				<v-toolbar flat color="rgba(0,0,0,0)">
					<v-btn-toggle v-model="btnValue" color="primary" mandatory dense group class="ml-n2">
						<v-btn :value="item.key" class="ml-2" v-for="(item, index) in btnGroup" :key="index" :to="item.url">{{ item.val }}</v-btn>
					</v-btn-toggle>
				</v-toolbar>
				<v-card-text class="pt-0">
					<div class="pl-4 font-weight-bold" style="background: rgba(204, 204, 204, 0.215); height: 48px; line-height: 48px; font-size: 0.75rem">文档</div>
					<div class="py-3 pl-3" style="line-height: 2.5em">
						用户对接基本流程：<a href="/wit-zswk-pui" target="_blank">说明文档</a><br />
						1.用户点击应用时平台自动追加用户stoken参数，应用接收并处理；<br />
						2.获取授权token：安全授权 > 1.1. 获取_接口授权码access_token；<br />
						3.解析获取的用户信息：安全授权 > 2.3. 获取_会话码对应登录用户ID信息；<br />
						4.获取用户部门详细信息：应用接口 > 5.3. 获取_用户详细信息；<br />
						5.自行设置本应用登录状态并跳转相应的页面<br />
						<p class="mt-4">
							<span class="font-weight-bold">wait.vue</span>
							(推荐由前端页面接收stoken令牌，可以实现过渡动画；也可以后端接收)
							<v-img src="https://wit.hzcl.org.cn/assets/img/wait.vue.png" width="600" contain></v-img>
						</p>
						<p class="mt-4">
							<span class="font-weight-bold">wait.java</span>
							(推荐将重要信息配置化，以方便切换测试环境和正式环境)
							<v-img src="https://wit.hzcl.org.cn/assets/img/wait.java.png" width="600" contain></v-img>
						</p>
					</div>
				</v-card-text>
			</v-card>
		</div>
	</v-container>
</template>
<script>
import Message from "@/components/message";
import Storage from "@/commons/storage";
// import Request from "@/commons/request";
export default {
	data: () => ({
		btnGroup: [
			{ key: "1", val: "开发单位", url: "/uams/apps-acid" },
			{ key: "2", val: "开发文档", url: "/uams/apps-docu" },
			{ key: "3", val: "服务接口", url: "/uams/apps-apis" },
			{ key: "0", val: "服务目录", url: "/uams/apps-abiz" },
		],
		btnValue: "2",
		user: {},
		entView: {},
	}),
	mounted() {
		this.user = Storage.get("_wit_acis_users");
	},
	methods: {
		//拷贝文本
		copy(txt) {
			navigator.clipboard.writeText(txt).then(() => {
				Message.toast("复制成功", { color: "success" });
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.title_box {
	display: inline-block;
	min-width: 88px;
	text-align: justify;
	text-align-last: justify;
}
::v-deep .v-data-table > .v-data-table__wrapper > table th {
	background: rgba(204, 204, 204, 0.215);
}
.copy_hover {
	background: rgba(162, 201, 255, 0.297);
	&::after {
		content: " 复制";
		color: rgb(0, 102, 255);
	}
}
</style>
